module.exports = __webpack_public_path__ + "assets/img/kv-6f0fbbff.jpg";